import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { UiContext } from "../../store/UiContext";
import { DEEP_LINK_URL } from "../../config";

export const PaymentConfirmationDialog = () => {
  const { showPaymentConfirmationDialog, setShowPaymentConfirmationDialog } =
    React.useContext(UiContext);

  const handleClose = () => {
    setShowPaymentConfirmationDialog(false);
    window.location.href = `${DEEP_LINK_URL}?screenName=Home`;
  };

  return (
    <Dialog
      open={showPaymentConfirmationDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Payment Completed"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Order is proceed and payment is completed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose} autoFocus>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
